import type { CSSProperties } from 'react';

import type { JSONContent } from '@tiptap/core';

import type { CustomAttribute, DreamRenderElementProps, EmptyChildren } from '../types';

export interface Testimonial {
  id: string;
  name: string;
  description: string;
  message: string;
  picture_url: string;
}

export type TestimonialCardSchema = {
  node: string;
  className: string;
  children: TestimonialCardSchema[];
};

type TestimonialMergeTag = 'testimonial.image' | 'testimonial.name' | 'testimonial.description' | 'testimonial.message';

export const TESTIMONIAL_FIELD_MAP: Record<TestimonialMergeTag, keyof Testimonial> = {
  'testimonial.image': 'picture_url',
  'testimonial.name': 'name',
  'testimonial.description': 'description',
  'testimonial.message': 'message',
};

export type TTestimonialAttributes = {
  id: string;
  height?: number;
  width?: number;
  mobile_hide?: boolean;
  desktop_hide?: boolean;
  customAttributes?: CustomAttribute;
  padding?: CSSProperties['padding'];
  insertedFromSidebar?: boolean;
  hasFakeData?: boolean;
  gap?: CSSProperties['gap'];
  shadow?: CSSProperties['boxShadow'];
  columns?: string;
  alignment?: 'left' | 'center' | 'right';
  nameFontFamily?: CSSProperties['fontFamily'];
  descriptionFontFamily?: CSSProperties['fontFamily'];
  messageFontFamily?: CSSProperties['fontFamily'];
  nameFontSize?: string;
  descriptionFontSize?: string;
  messageFontSize?: string;
  imageSize?: string;
  imageRadius?: string;
  mergeTag?: TestimonialMergeTag;
  borderWidth?: CSSProperties['borderWidth'];
  borderRadius?: CSSProperties['borderRadius'];
  borderStyle?: CSSProperties['borderStyle'];
  borderColor?: CSSProperties['borderColor'];
  backgroundColor?: CSSProperties['backgroundColor'];
  nameColor?: CSSProperties['color'];
  descriptionColor?: CSSProperties['color'];
  messageColor?: CSSProperties['color'];
  data: Testimonial[];
  cardStructure: TestimonialCardSchema;
  cardStructureV2: TestimonialCardSchema;
  structureTiptapState: JSONContent;
  structureTiptapStateDraft: JSONContent;
};

export type TTestimonialsElement = {
  type: 'testimonials';
  attrs: TTestimonialAttributes;
  content: EmptyChildren;
};

export type TestimonialsElementProps = DreamRenderElementProps<TTestimonialsElement>;
